import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ReactComponent as Image404 } from "../../images/comingsoon.svg";

const UserComingSoon = () => {
  const location = useLocation();
  const { hash, pathname, search } = location;

  function comingsoonMessage(pathname) {
    let message = "";
    switch (pathname) {
      case "/NewsMedia":
        message = "News Media Page is coming soon.";
        break;
      case "/ComingSoon":
        message = "Zulal Wallet Page is coming soon.";
        break;
      default:
        message = "This page is coming soon.";
        break;
    }

    return message;
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="text-navarbarText text-3xl font-poppins font-medium mb-8">
          Coming Soon...
          <p className="text-base text-darkTextColor font-poppins font-normal">
            <br /> We are working on this page, soon it will be available to
            enhance user experience.
          </p>
        </div>
      </div>

      <div className="flex flex-col items-start justify-center font-poppins">
        <div className="col-span-full">
          <div className="mt-4 mb-4">
            <Image404 />
          </div>
          <div className="text-red-500 text-base font-normal uppercase tracking-widest">
            STAY TUNED - {comingsoonMessage(pathname)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserComingSoon;
